<div
  class="flex flex-col items-center justify-center bg-[#1A1A1A] rounded pt-10 pb-10 pl-10 pr-10 gap-6 w-full h-fit min-[1024px]:rounded-lg min-[1024px]:pt-16 min-[1024px]:pb-16 min-[1024px]:pl-16 min-[1024px]:pr-16 min-[1024px]:justify-start"
>
  <!-- Heading -->
  <div class="flex flex-col items-center justify-start h-fit w-full flex-nowrap">
    <span
      class="flex flex-row flex-wrap items-start justify-start h-fit w-fit text-[#E2E2E2] text-3xl font-bold tracking-normal leading-9 text-center align-middle min-[1024px]:text-5xl min-[1024px]:leading-[48px] min-[1024px]:w-[446px]"
    >
      Show Us Your Skills
    </span>
  </div>

  <!-- Description Container -->
  <div
    class="flex flex-col items-center justify-start h-fit w-full max-w-[448px] flex-nowrap pb-4 min-[1024px]:max-w-[576px] min-[1024px]:w-[576px]"
  >
    <span
      class="h-[96px] w-[257px] text-[#E2E2E2] text-base font-normal tracking-normal leading-6 text-center align-middle min-[1024px]:h-fit min-[1024px]:w-[574px] min-[1024px]:text-xl min-[1024px]:leading-7"
    >
      Skip the generic interview. Take our coding challenge and show us how you think. All
      submissions get a code review by a <span class="font-bold">human</span>.
    </span>
  </div>

  <!-- Button -->
  <app-secondary-button
    [size]="'large'"
    [label]="'Start Challenge'"
    (buttonClicked)="navigateToChallenge()"
    class="w-fit h-fit"
  ></app-secondary-button>
</div>
